<template>
  <h1 class="text-xs-center my-4">
    Bạn không có quyền truy cập
  </h1>
</template>

<script>
export default {}
</script>
